import React from 'react';
import ContentLoader from 'react-content-loader';
import {isRTL} from '../../../Localization';

export const SkeltonLoader = props => (
    <ContentLoader
        speed={5}
        viewBox="0 0 296 430"
        backgroundColor="#f4f6f8"
        foregroundColor="#d6dddf"
        rtl={isRTL()}
        {...props}
    >
        <rect x="0" y="0" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="4" rx="3" ry="3" width="29" height="16" />
        <rect x="0" y="32" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="41" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="45" rx="3" ry="3" width="45" height="16" />
        <rect x="0" y="73" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="82" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="86" rx="3" ry="3" width="47" height="16" />
        <rect x="0" y="114" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="123" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="125" rx="3" ry="3" width="226" height="16" />
        <rect x="0" y="153" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="162" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="166" rx="3" ry="3" width="76" height="16" />
        <rect x="0" y="194" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="205" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="209" rx="3" ry="3" width="183" height="16" />
        <rect x="0" y="237" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="246" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="250" rx="3" ry="3" width="224" height="16" />
        <rect x="0" y="288" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="297" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="301" rx="3" ry="3" width="159" height="16" />
        <rect x="0" y="319" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="328" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="332" rx="3" ry="3" width="102" height="16" />
        <rect x="0" y="360" rx="3" ry="3" width="296" height="1" />
        <rect x="0" y="369" rx="3" ry="3" width="24" height="24" />
        <rect x="34" y="373" rx="3" ry="3" width="53" height="16" />
        <rect x="0" y="401" rx="3" ry="3" width="296" height="1" />
    </ContentLoader>
);
